import Vue from "vue";
import HomeClinicHeader from "@/components/Clinics/Clinic.vue";
import ClinicMessage from "@/components/Clinics/ClinicMessage/ClinicMessage.vue";
import ClinicServices from "@/components/Home/Services/Services.vue";
import ServiceAppoint from "@/components/Home/Services/ServiceAppoint/ServiceAppoint.vue";
import SideModal from "@c/Util/SideModal/SideModal.vue";
import Service from "@/api/Services/Service";
import ServiceEntity from "@/components/Home/Services/ServiceEntity";
import Clinic from "@/api/Services/Clinic";

import { Component } from "vue-property-decorator";
import { ServiceModal } from "@/components/Home/Services/ServiceInterface";
import { ClinicInterface } from "@/api/Interfaces/ClinicInterface";
import { AddressInterface } from "@/api/Interfaces/AddressInterface";

import * as LogoClinicarx from "@/assets/images/Logo_nova.png";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";

const ClinicScreenProps = Vue.extend({
  props: {
    isScrolling: {
      type: Boolean,
      default: false,
    },
  },
});
@Component({
  name: "HomeClinic",
  components: {
    "home-clinic-header": HomeClinicHeader,
    "clinic-message": ClinicMessage,
    "clinic-services": ClinicServices,
    "service-appoint": ServiceAppoint,
    SideModal,
  },
})
export default class HomeClinic extends ClinicScreenProps {
  service: Service | null = null;
  clinicId: string | null = null;
  cx_header_logo = LogoClinicarx;
  cx_isScrolling = this.isScrolling;
  cx_Service = new Service();
  cx_serviceModal: ServiceModal | null = null;
  cx_serviceModalEmpty: ServiceModal | null = null;
  cx_clinicAddress = new Clinic();

  /**
   * Objeto de serviço
   *
   * @var     {ClinicInterface} cx_clinic
   * @since   0.1.0
   */
  cx_clinic: ClinicInterface | null = null;

  /**
   * Objeto de serviço
   *
   * @var     {AddressInterface} cx_address
   * @since   0.1.0
   */
  cx_address: AddressInterface | null = null;

  constructor() {
    super();
  }

  mounted(): void {
    this.cx_header_logo = LogoClinicarx;
    this.clinicId = this.$route.name == "ClinicScreen" ? this.$route.params.clinicId : "";

    this.cx_serviceModalEmpty = {
      selectedService: null,
      clinic: null,
      modalOpened: false,
    };

    this.cx_serviceModal = this.cx_serviceModalEmpty;
    this.verifyAddressClinic();
  }

  clearServiceModal(): void {
    this.cx_serviceModal = this.cx_serviceModalEmpty;
  }

  closeModal(event: Event): void {
    if (!event) this.clearServiceModal();
  }

  async openScheduleModal(service: ServiceInterface): Promise<void> {
    this.cx_serviceModal = {
      selectedService: service,
      clinic: this.cx_clinic,
      modalOpened: true,
    };
  }

  verifyAddressClinic() {
    this.cx_clinicAddress.getClinicsWithAddress(this.clinicId).then((response: any) => {
      this.cx_clinic = response.data;
      if (!this.cx_clinic) {
        this.$router.push({ name: "Home" });
      }
    });
  }
}
